import './legal.css';

const year = document.querySelector<HTMLElement>('#current-year');
if (year) year.textContent = String(new Date().getFullYear());
